var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.75024 4.25C5.75024 3.00736 6.7576 2 8.00024 2H16.0002C17.2429 2 18.2502 3.00736 18.2502 4.25V19.75C18.2502 20.9926 17.2429 22 16.0002 22H8.00024C6.7576 22 5.75024 20.9926 5.75024 19.75V4.25ZM10.2502 18.25C10.2502 18.6642 10.586 19 11.0002 19H13.0002C13.4145 19 13.7502 18.6642 13.7502 18.25C13.7502 17.8358 13.4145 17.5 13.0002 17.5H11.0002C10.586 17.5 10.2502 17.8358 10.2502 18.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 17.5C10.586 17.5 10.2502 17.8358 10.2502 18.25C10.2502 18.6642 10.586 19 11.0002 19H13.0002C13.4145 19 13.7502 18.6642 13.7502 18.25C13.7502 17.8358 13.4145 17.5 13.0002 17.5H11.0002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoPhone);
export default __webpack_public_path__ + "static/media/DuoPhone.401c041dbc56ee18806d9110af1df07d.svg";
export { ForwardRef as ReactComponent };